import React from 'react'
import Image from 'next/legacy/image'
import { useTranslation } from 'next-i18next'
import clsx from 'clsx'
import { GetVenueDetailQuery } from 'generated/graphcms'

type Props = {
  facility: Exclude<GetVenueDetailQuery['venue'], null | undefined>['meetingFacilities'][0]
  imageWidth?: number
  imageHeight?: number
  className?: string
}

const CardFacilities: React.FC<Props> = ({
  facility,
  imageWidth = 370,
  imageHeight = 300,
  className = undefined,
}) => {
  const { t } = useTranslation()
  return (
    <div className={clsx('flex flex-col', className)}>
      {facility.thumbnail && (
        <Image
          src={facility.thumbnail.url_740_600}
          width={imageWidth}
          height={imageHeight}
          alt={facility.title}
          className="rounded-2xl"
          layout="responsive"
        />
      )}
      <h3 className="my-3 text-xl font-semibold">{facility.title}</h3>

      {facility.description && (
        <p className="mb-3 pb-2 text-sm text-gray-800">{facility.description}</p>
      )}

      {(facility.equipment || facility.duration || facility.groupSize || facility.price) && (
        <div className="mb-3 mt-auto space-y-1 pb-3 text-sm">
          {facility.equipment && (
            <div className="flex space-x-1">
              <div className="w-32 flex-shrink-0 text-gray-500">
                {t('venue.facilities.equipment')}
              </div>
              <div>{facility.equipment}</div>
            </div>
          )}
          {facility.duration && (
            <div className="flex space-x-1">
              <div className="w-32 flex-shrink-0 text-gray-500">
                {t('venue.facilities.duration')}
              </div>
              <div>{facility.duration}</div>
            </div>
          )}
          {facility.groupSize && (
            <div className="flex space-x-1">
              <div className="w-32 flex-shrink-0 text-gray-500">
                {t('venue.facilities.groupSize')}
              </div>
              <div>{facility.groupSize}</div>
            </div>
          )}
          {facility.price && (
            <div className="flex space-x-1">
              <div className="w-32 flex-shrink-0 text-gray-500">{t('venue.facilities.price')}</div>
              <div>{facility.price}</div>
            </div>
          )}
        </div>
      )}
      {facility.finePrint && <div className="text-xs text-gray-500">{facility.finePrint}</div>}
    </div>
  )
}

export default CardFacilities
